import React from 'react';
import './CSS/App.css';
import Home from './Components/Home';

const App = () => {
  return (
    <>
      <Home />
    </>
  )
};

export default App;
